import {tns} from "tiny-slider/src/tiny-slider";

export function initializeSliders() {
    window.addEventListener("load", () => {
        Array.from(document.querySelectorAll(".fi-slider"))
            .forEach(slider => initializeSlider(slider));
    });
}

function initializeSlider(el) {
    const defaultOptions = {
        container: el,
        autoplay: true,
        autoplayButtonOutput: false,
        autoplayTimeout: 12000,
        controls: false,
        items: 1,
        lazyload: true,
        slideBy: "page",
        speed: 900,
        mode: "gallery",
        nav: false
    };
    const options = JSON.parse(el.dataset.options || "{}");

    const slider = tns(Object.assign({}, defaultOptions, options));

    slider.events.on("indexChanged", () => window.dispatchEvent(new CustomEvent("tns:update")));
    slider.events.on("transitionStart", () => window.dispatchEvent(new CustomEvent("tns:update")));
}
